export default __webpack_public_path__ + "static/media/dog-rMIN.jpg.069bf508.txt";